;(function(){
	var wrapper = document.querySelector('.js-contact');

	if (!wrapper) {
		return;
	}

	var input = wrapper.querySelector('select.js-contact__input');
	var toggleManual = wrapper.querySelector('#manually-enter-address');
	var groups = [].slice.call(wrapper.querySelectorAll('.js-contact__group'));
	var notice = wrapper.querySelector('.contact__packaging-notice');
	var commentsPlaceholderInitial = wrapper.querySelector('.comments').placeholder;
	var commentsPlaceholder = wrapper.querySelector('.comments');
	var commentsLabel = wrapper.querySelector('.comments-label');

	var toggleGroup = function(group) {
		var hidden = !input.value || (group.dataset.contactProduct && input.value !== 'product') || input.value == 'packaging';

		group.classList[hidden ? 'add' : 'remove']('is-hidden');
	};

	var onChange = function() {
		if (input.value == 'packaging') {
			if (notice.classList.contains('hidden')) {
				notice.classList.remove('hidden');
			}
		} else if (input.value == 'tester') {
			commentsPlaceholder.placeholder = 'Your favourite hobby or interest*';
			commentsLabel.innerHTML = 'Hobby / interest<b>*</b>';
		} else {
			commentsPlaceholder.placeholder = commentsPlaceholderInitial;
			commentsLabel.innerHTML = 'Comments<b>*</b>'
			notice.classList.add('hidden');
		};

		groups.forEach(toggleGroup);
	};

	var toggleManualAddress = function() {
		manualAddress = !manualAddress;
		postcodeTracking = !postcodeTracking;
		toggleAddressVisibility(addressGroups, !manualAddress);
	}

	input.addEventListener('change', onChange);
	toggleManual.addEventListener('click', toggleManualAddress);
	onChange();
}());

var manualAddress = false;
var addressGroups = document.querySelectorAll('.js-address__group');
var postcodeTracking = true;
var hasBeenToggled = false;

function toggleAddressVisibility(addressGroups, isHiding) {
	if(!isHiding) {
		Array.prototype.forEach.call(addressGroups, function(addressGroup){
			addressGroup.classList.remove('is-hidden');
		});
	} else {
		var addressFields = addressGroups[0].childNodes;
		var shouldHide = true;
		for (var i = 0; i < addressFields.length; i++){
			if(addressFields[i].children) {
				if(addressFields[i].children[0].value !== '' && addressFields[i].children[0].id !== 'contact-country') {
					shouldHide = false;
				}
			}
		}
		if(shouldHide) {
			Array.prototype.forEach.call(addressGroups, function(addressGroup){
				addressGroup.classList.add('is-hidden');
			});
		}
		initPCA();
	}
}

function initPCA(){
if (typeof pca != "undefined") {
	var fields = [
		{ element: "contact-address-1", field: "Line1", mode: pca.fieldMode.POPULATE },
		{ element: "contact-address-2", field: "Line2", mode: pca.fieldMode.POPULATE },
		{ element: "contact-town", field: "City", mode: pca.fieldMode.POPULATE },
		{ element: "contact-postcode", field: "PostalCode" },
		{ element: "contact-country", field: "CountryName", mode: pca.fieldMode.COUNTRY }
	];

	var options = {
		key: "EC11-GA91-YM32-KU49",
		search: { countries: "GB,USA,CAN,AU" },
		setCountryByIP: true
	}

	var control = new pca.Address(fields, options);

	control.listen("populate", function() {
		toggleAddressVisibility(addressGroups, false);
	});

	control.listen("search", function() {
		if(postcodeTracking && !manualAddress && hasBeenToggled) {
			initPCA();
			hasBeenToggled = true;
			postcodeTracking = true;
		} else if(!postcodeTracking && manualAddress) {
			control.destroy();
			postcodeTracking = false;
		}
	});
}
}
initPCA();
